import { termMaxConfigByChain } from '@1delta/data-sdk'
import { MulticallRetryFunction } from '../../types/providers'
import { GenericTokenList } from '../../types/general'
import { fetchTermMaxVaultsFromApi } from './fetchFromApi'
import { fetchTermMaxVaultsFromChain } from './fetchFromChain'
import type { TermMaxVaults } from './types'

/**
 * Fetch TermMax curated vaults for a chain — API-first with an on-chain
 * fallback, the same posture as the Morpho vault provider.
 *
 * The API (`GET /vault/list`) is preferred because it carries things the chain
 * does not cheaply expose: the net APR (on-chain `apr()` reverts on the
 * deployed 2.0.0 vaults), curator NAMES, deposit caps, TMX reward APR and the
 * base-yield pool. The on-chain reader takes over when it is unavailable, and
 * its rate derivation was cross-validated against the API to 3 decimals.
 */
export const fetchTermMaxVaults = async (
  chainId: string,
  multicallRetry: MulticallRetryFunction,
  prices: { [asset: string]: number } = {},
  tokenList: GenericTokenList = {},
): Promise<TermMaxVaults> => {
  if (!termMaxConfigByChain(chainId)) return {}

  const fromApi = await fetchTermMaxVaultsFromApi(chainId, prices, tokenList)
  // `null` = upstream failed; `{}` = the chain genuinely has no vaults. Only
  // the former is worth an on-chain round trip.
  if (fromApi !== null) return fromApi

  return fetchTermMaxVaultsFromChain(chainId, multicallRetry, prices, tokenList)
}
